import { HttpRequestStatus } from 'model/enums/httpRequestStatus';
import { ShareholderGetAllByPersonIdActionTypes, ShareholderGetAllByPersonIdState } from 'reducer/shareholder/get-all-by-person-id/types';
import { Reducer } from 'redux';

export const initialState: ShareholderGetAllByPersonIdState = {
    status: HttpRequestStatus.NOOP,
    error: undefined,
    shareholders: undefined
};

const reducer: Reducer<ShareholderGetAllByPersonIdState> = (state = initialState, action): ShareholderGetAllByPersonIdState => {
    switch (action.type) {
        case ShareholderGetAllByPersonIdActionTypes.SHAREHOLDER_GET_ALL_BY_PERSON_ID_REQUEST: {
            return { ...state, status: HttpRequestStatus.ONGOING, shareholders: undefined, error: undefined };
        }
        case ShareholderGetAllByPersonIdActionTypes.SHAREHOLDER_GET_ALL_BY_PERSON_ID_SUCCESS: {
            return { ...state, status: HttpRequestStatus.SUCCESS, shareholders: action.payload, error: undefined };
        }
        case ShareholderGetAllByPersonIdActionTypes.SHAREHOLDER_GET_ALL_BY_PERSON_ID_ERROR: {
            return { ...state, status: HttpRequestStatus.ERROR, error: action.payload };
        }
        case ShareholderGetAllByPersonIdActionTypes.SHAREHOLDER_GET_ALL_BY_PERSON_ID_RESET_STATE: {
            return { ...initialState };
        }
        default: {
            return state;
        }
    }
};

export { reducer as shareholderGetAllByPersonIdReducer };
